/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { IVideoPlayerViewProps } from './video-player';

const VideoPlayerView: React.FC<IVideoPlayerViewProps> = props => (
    <div
        id={props.id}
        className='ms-video-player'
        {...props.renderModuleAttributes(props)}
    >
            {props.player}
    </div>
);

export default VideoPlayerView;